// Single FAQ accordion row (presentational).
export const CATEGORY_LABELS = {
  all: "All",
  registration: "Registration",
  programme: "Programme",
  cpf: "CPF retirement",
  venue: "Venue",
};
export const CATEGORY_ORDER = ["registration", "programme", "cpf", "venue"];

export const FaqItem = ({ item, index, show, isOpen, onToggle }) => (
  <div
    className={`cfl-faq-item${isOpen ? " is-open" : ""}`}
    data-category={item.category}
    data-testid={`faq-item-${index}`}
    hidden={!show}
  >
    <button type="button" className="cfl-faq-summary" aria-expanded={isOpen} onClick={onToggle}>
      <span className="cfl-faq-number">{item.number}</span>
      <span className="cfl-faq-question">{item.q}</span>
      <span className="cfl-faq-category">{CATEGORY_LABELS[item.category] || item.category}</span>
      <span className="cfl-faq-toggle" aria-hidden="true">+</span>
    </button>
    {isOpen && (
      <div className="cfl-faq-answer">
        <p>{item.a}</p>
        {item.link && (
          <a href={item.link.url} target="_blank" rel="noopener noreferrer">
            {item.link.label} ↗
          </a>
        )}
      </div>
    )}
  </div>
);
